import React from "react";
import styled from "styled-components";

import Background from "../../../assets/lunch/lunch-bg-02.png";
import BubbleImage from "../../../assets/popup_bubble.png";

import GamePageLayout from "../GamePageLayout";

const Image = styled.img`
  position: absolute;
  top: 237px;
`;

const LunchPage2 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      rawContent
      onClickNext={() => setCurrentPage("lunch-3")}
    >
      <Image src={BubbleImage} alt="메시지 버블" />
    </GamePageLayout>
  );
};

export default LunchPage2;
